export default __webpack_public_path__ + "static/media/ukraine-fence.cf95f00b.jpg";